export const colors = {
  // Primary brand colors
  primary: {
    main: '#DC2626', // red-600
    light: '#FCA5A5', // red-300
    dark: '#B91C1C', // red-700
    hover: '#FEE2E2', // red-50
  },
  
  // Secondary brand colors (using red/purple instead of blue)
  secondary: {
    main: '#DC2626', // red-600 (same as primary for consistency)
    light: '#FCA5A5', // red-300
    dark: '#B91C1C', // red-700
    hover: '#FEE2E2', // red-50
  },
  
  // Accent colors
  accent: {
    purple: '#8B5CF6', // purple-500
    pink: '#EC4899', // pink-500
    red: '#DC2626', // red-600 (brand color)
    green: '#10B981', // emerald-500
  },
  
  // Text colors with better contrast
  text: {
    light: '#FFFFFF',
    dark: '#1F2937', // gray-800
    muted: '#6B7280', // gray-500
    primary: '#1F2937', // gray-800
    secondary: '#6B7280', // gray-500
    inverse: '#FFFFFF',
  },
  
  // Background colors
  background: {
    light: '#FFFFFF',
    dark: '#111827', // gray-900
    transparent: 'transparent',
    primary: '#FFFFFF',
    secondary: '#F9FAFB', // gray-50
    tertiary: '#F3F4F6', // gray-100
  },
  
  // Border colors
  border: {
    light: '#E5E7EB', // gray-200
    dark: '#374151', // gray-700
    primary: '#E5E7EB', // gray-200
    secondary: '#D1D5DB', // gray-300
    accent: '#DC2626', // red-600 (brand color)
  },
  
  // Scrollbar colors
  scrollbar: {
    track: '#F3F4F6', // gray-100
    thumb: '#D1D5DB', // gray-300
    hover: '#9CA3AF', // gray-400
  },
  
  // Theme-specific colors for book reader with proper contrast
  themes: {
    light: {
      background: '#FFFFFF',
      text: '#1F2937', // gray-800 - dark text on light background
      surface: '#F9FAFB', // gray-50 - subtle surface color
      border: '#E5E7EB', // gray-200 - visible borders
      accent: '#DC2626', // red-600 - brand color
      input: {
        background: '#FFFFFF',
        text: '#1F2937',
        border: '#D1D5DB',
        placeholder: '#9CA3AF'
      },
      themeButton: {
        selected: {
          background: '#DC2626', // red-600
          text: '#FFFFFF',
          border: '#DC2626'
        },
        unselected: {
          background: '#FFFFFF',
          text: '#1F2937', // gray-800
          border: '#D1D5DB' // gray-300
        }
      }
    },
    dark: {
      background: '#0F172A', // slate-900 - darker background
      text: '#F8FAFC', // slate-50 - light text on dark background
      surface: '#1E293B', // slate-800 - visible surface
      border: '#475569', // slate-600 - visible borders
      accent: '#F87171', // red-400 - lighter red for dark theme
      input: {
        background: '#1E293B', // slate-800
        text: '#F8FAFC', // slate-50
        border: '#475569', // slate-600
        placeholder: '#94A3B8' // slate-400
      },
      themeButton: {
        selected: {
          background: '#F87171', // red-400
          text: '#0F172A', // slate-900
          border: '#F87171'
        },
        unselected: {
          background: '#1E293B', // slate-800
          text: '#F8FAFC', // slate-50
          border: '#475569' // slate-600
        }
      }
    },
    sepia: {
      background: '#FDF8F3', // warm cream background like Kindle
      text: '#2D1810', // deep brown text for excellent readability
      surface: '#F5E6D3', // warm beige surface like Kindle pages
      border: '#D4A574', // warm brown border like Kindle
      accent: '#B45309', // amber-600 - warm accent color
      input: {
        background: '#FDF8F3', // warm cream
        text: '#2D1810', // deep brown
        border: '#D4A574', // warm brown
        placeholder: '#92400E' // amber-800
      },
      themeButton: {
        selected: {
          background: '#B45309', // amber-600
          text: '#FFFFFF',
          border: '#B45309'
        },
        unselected: {
          background: '#FDF8F3', // warm cream
          text: '#2D1810', // deep brown
          border: '#D4A574' // warm brown
        }
      }
    }
  },
  
  // Button colors using brand colors
  button: {
    primary: {
      background: '#DC2626', // red-600
      text: '#FFFFFF',
      hover: '#B91C1C', // red-700
      border: '#DC2626', // red-600
    },
    secondary: {
      background: '#8B5CF6', // purple-500 (instead of blue)
      text: '#FFFFFF',
      hover: '#7C3AED', // purple-600
      border: '#8B5CF6', // purple-500
    },
    outline: {
      background: 'transparent',
      text: '#DC2626', // red-600
      hover: '#FEE2E2', // red-50
      border: '#DC2626', // red-600
    },
    sepia: {
      primary: {
        background: '#B45309', // amber-600 - warm brown
        text: '#FFFFFF',
        hover: '#92400E', // amber-800 - darker brown
        border: '#B45309', // amber-600
      },
      secondary: {
        background: '#D4A574', // warm brown
        text: '#2D1810', // deep brown text
        hover: '#B45309', // amber-600
        border: '#D4A574', // warm brown
      }
    }
  },
  
  // Input field colors with proper contrast
  input: {
    background: '#FFFFFF',
    text: '#1F2937',
    border: '#D1D5DB',
    focus: '#DC2626', // red-600 (brand color)
    placeholder: '#9CA3AF',
    disabled: '#F3F4F6',
  }
}; 